/* */ 
"use strict";
var lang_1 = require('../facade/lang');
var collection_1 = require('../facade/collection');
var exceptions_1 = require('../facade/exceptions');
var view_type_1 = require('./view_type');
var element_ref_1 = require('./element_ref');
var view_container_ref_1 = require('./view_container_ref');
var AppElement = (function() {
  function AppElement(index, parentIndex, parentView, nativeElement) {
    this.index = index;
    this.parentIndex = parentIndex;
    this.parentView = parentView;
    this.nativeElement = nativeElement;
    this.nestedViews = null;
    this.componentView = null;
  }
  Object.defineProperty(AppElement.prototype, "elementRef", {
    get: function() {
      return new element_ref_1.ElementRef(this.nativeElement);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AppElement.prototype, "vcRef", {
    get: function() {
      return new view_container_ref_1.ViewContainerRef_(this);
    },
    enumerable: true,
    configurable: true
  });
  AppElement.prototype.initComponent = function(component, componentConstructorViewQueries, view) {
    this.component = component;
    this.componentConstructorViewQueries = componentConstructorViewQueries;
    this.componentView = view;
  };
  Object.defineProperty(AppElement.prototype, "parentInjector", {
    get: function() {
      return this.parentView.injector(this.parentIndex);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AppElement.prototype, "injector", {
    get: function() {
      return this.parentView.injector(this.index);
    },
    enumerable: true,
    configurable: true
  });
  AppElement.prototype.mapNestedViews = function(nestedViewClass, callback) {
    var result = [];
    if (lang_1.isPresent(this.nestedViews)) {
      this.nestedViews.forEach(function(nestedView) {
        if (nestedView.clazz === nestedViewClass) {
          result.push(callback(nestedView));
        }
      });
    }
    return result;
  };
  AppElement.prototype.attachView = function(view, viewIndex) {
    if (view.type === view_type_1.ViewType.COMPONENT) {
      throw new exceptions_1.BaseException("Component views can't be moved!");
    }
    var nestedViews = this.nestedViews;
    if (nestedViews == null) {
      nestedViews = [];
      this.nestedViews = nestedViews;
    }
    collection_1.ListWrapper.insert(nestedViews, viewIndex, view);
    var refRenderNode;
    if (viewIndex > 0) {
      var prevView = nestedViews[viewIndex - 1];
      refRenderNode = prevView.lastRootNode;
    } else {
      refRenderNode = this.nativeElement;
    }
    if (lang_1.isPresent(refRenderNode)) {
      view.renderer.attachViewAfter(refRenderNode, view.flatRootNodes);
    }
    view.addToContentChildren(this);
  };
  AppElement.prototype.detachView = function(viewIndex) {
    var view = collection_1.ListWrapper.removeAt(this.nestedViews, viewIndex);
    if (view.type === view_type_1.ViewType.COMPONENT) {
      throw new exceptions_1.BaseException("Component views can't be moved!");
    }
    view.renderer.detachView(view.flatRootNodes);
    view.removeFromContentChildren(this);
    return view;
  };
  return AppElement;
}());
exports.AppElement = AppElement;
